import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import { CommonEventProperties } from '../../utils/CommonParams'

export const PopupClickedEventSchema: EventSchema = {
  eventName: EN.POPUP_CLICKED,
  params: {
    ...CommonEventProperties,
    POPUP_NAME: EPK.POPUP_NAME,
    POPUP_TITLE: EPK.POPUP_TITLE,
    POPUP_OPTION: EPK.POPUP_OPTION,
    POPUP_OPTION_SELECTED: EPK.POPUP_OPTION_SELECTED
  },
}
